import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EventsService } from '../../services/events.service';
import { Event } from '../../interfaces/event';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { EventsShowcaseComponent } from '../events-showcase/events-showcase.component';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [CommonModule, TranslateModule, EventsShowcaseComponent, ButtonComponent],
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss']
})
export class EventsComponent implements OnInit {
  events: Event[] = [];
  isLoadingEvents: boolean = true;

  constructor(private eventsService: EventsService, private router: Router) {}

  ngOnInit(): void {
    this.eventsService.getEvents().subscribe(
      (events) => {
        this.events = events;
        this.isLoadingEvents = false;
      },
      (error) => {
        console.error('Error al obtener los eventos:', error);
        this.isLoadingEvents = false;
      }
    );
  }

  goToNewHop(): void {
    this.router.navigate(['/new-hop']);
  }
}
